/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { handleOAuthCallback } from 'services/user'
import { notification } from 'antd'
import cometchatIcon from '@assets/images/product/logo-new.svg'

const OauthCallback = () => {
  const [status, setStatus] = useState('Please wait, login in progress...')
  const dispatch = useDispatch()

  useEffect(() => {
    async function processOAuth() {
      try {
        const result = await handleOAuthCallback(dispatch)
        setStatus(result.status)
      } catch (error) {
        setStatus('Login failed. Please try again.')
        notification.error({
          message: error.response?.data?.error?.message || 'Authentication failed',
          placement: 'bottomRight',
        })
      }
    }

    processOAuth()
  }, [dispatch])

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        textAlign: 'center',
        flexDirection: 'column',
        gap: '20px',
      }}
    >
      <img style={{ width: '128px', fontSize: '600px' }} src={cometchatIcon} alt="CometChat" />
      {status}
    </div>
  )
}

export default OauthCallback
